import React from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select

class StyleSelect extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    function tagRender(props) {
      const { value, closable, onClose } = props
      const onPreventMouseDown = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
      return (
        <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
          {value}
        </Tag>
      )
    }

    return (
      <Select
        placeholder='please select style'
        {...this.props}
        mode='multiple'
        allowClear
        showArrow
        tagRender={tagRender}
        style={{ width: '100%' }}
      >
        <Option value='fine-art'>Fine Art</Option>
        <Option value='abstract'>Abstract</Option>
        <Option value='modern'>Modern</Option>
        <Option value='street-art'>Street Art</Option>
        <Option value='pop-art'>Pop Art</Option>
        <Option value='others'>Others</Option>
      </Select>
    )
  }
}

export default StyleSelect
